import { AppDrawer } from '@superdispatch/ui';
import { RatingShipperForm, useRatingShipperForm } from './RatingShipperForm';
import { Form, FormikProvider } from 'formik';
import { useShipperProfile } from '../shipper/LoadboardShipperAPI';

const FORM_ID = 'shipper-rating-form';

interface ShipperRatingDrawerContentProps {
  shipperGUID: string;
  onSuccess: () => void;
}

function ShipperRatingDrawerContent({
  shipperGUID,
  onSuccess,
}: ShipperRatingDrawerContentProps) {
  const { formik } = useRatingShipperForm({ guid: shipperGUID, onSuccess });
  return (
    <FormikProvider value={formik}>
      <Form id={FORM_ID}>
        <RatingShipperForm />
      </Form>
    </FormikProvider>
  );
}

export interface ShipperRatingDrawerProps {
  open: boolean;
  shipperGUID: string;
  onClose: () => void;
}

export function ShipperRatingDrawer({
  open,
  shipperGUID,
  onClose,
}: ShipperRatingDrawerProps) {
  const { data: shipperProfile } = useShipperProfile(shipperGUID);
  return (
    <AppDrawer
      open={open}
      onClose={onClose}
      title={`Leave a rating for ${shipperProfile?.name}`}
      size="lg"
      primaryAction={{ label: 'Submit Rating', form: FORM_ID, type: 'submit' }}
    >
      <ShipperRatingDrawerContent
        shipperGUID={shipperGUID}
        onSuccess={onClose}
      />
    </AppDrawer>
  );
}
